import { put, select, all } from "redux-saga/effects";
import selectors from "rdx/selectors";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { regionalPowurlineOverrideApi } from "rdx/modules/regionalPowurlineOverride/endpoints";
import { REGIONAL_POWURLINE_OVERRIDE_TAGS } from "rdx/modules/regionalPowurlineOverride/tags";
import { camelizeKeys, keysToSnakeCase } from "lib/helpers";
import messages from "../messages";

function* updateEnterpriseOrg(action) {
  const params = keysToSnakeCase(action.payload);
  const { success, data, error } = yield* makeRequest.post("/enterprise/settings", params);

  if (success && data) {
    const currentSettings = yield select(selectors.getEnterpriseOrg);
    const payload = camelizeKeys(action.payload);
    const orgName = payload.name;
    delete payload.name;

    yield all([
      put(
        actions.setEnterpriseOrg({
          ...currentSettings,
          name: orgName || currentSettings.name,
          ...(payload.enterpriseLogo?.length > 0 && { enterpriseLogo: payload.enterpriseLogo }),
          ...(payload.enterpriseLogo === null && { enterpriseLogo: "" }),
          settings: {
            ...currentSettings.settings,
            ...payload,
          },
        }),
      ),
      put(actions.getEnterpriseCobranding()),
      put(
        actions.newSuccessEvent({
          message: messages.UPDATE_ENTERPRISE_ORG_SUCCESS,
        }),
      ),
      put(
        actions.setAlertMessageVisible({
          message: messages.UPDATE_ENTERPRISE_ORG_SUCCESS,
          severity: "success",
        }),
      ),
      put(
        regionalPowurlineOverrideApi.util.invalidateTags([
          REGIONAL_POWURLINE_OVERRIDE_TAGS.REGIONAL_POWURLINE_OVERRIDES,
        ]),
      ),
    ]);
  } else {
    yield put(
      actions.setAlertMessageVisible({
        message: messages.ERROR_UPDATING_ENTERPRISE_SETTINGS,
        severity: "error",
      }),
    );
    return getErrorActions({
      error,
      message: messages.ERROR_UPDATING_ENTERPRISE_SETTINGS,
    });
  }
  return null;
}

export default updateEnterpriseOrg;
